import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import socketPlugin from "./plugins/socket";
import { createVuetify } from 'vuetify';
import 'vuetify/styles';

// Importa los componentes y directivas de Vuetify explícitamente
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

const vuetify = createVuetify({
  components,
  directives,
});

import '@mdi/font/css/materialdesignicons.css'

// Iniciar Vue con Vuetify
createApp(App)
  .use(router)
  .use(vuetify) // <- Asegúrate de que Vuetify se está usando aquí
  .use(store)
  .use(socketPlugin)
  .mount("#app");
